export const FormStyle = {
  inputStyle: {
    backgroundColor: "white",
    boxShadow: 5,
    borderRadius: "1rem",
  
  },
}
